import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine10 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#DC9600"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5899 12.1033C20.5899 9.04355 19.8018 5.17694 15.8035 5.17694C11.8051 5.17694 10.9419 9.04355 10.9419 12.1033C10.9419 15.163 11.7303 19.0296 15.7284 19.0296C19.7264 19.0296 20.5899 15.163 20.5899 12.1033ZM9.26349 5.44016V18.6921H6.44792V8.27424C5.99714 8.63085 4.66462 9.32529 4.17653 9.56946L3.4821 9.92607L2.58105 7.89885L3.38818 7.52346C4.92732 6.79172 6.35401 5.90946 6.95453 5.44016H9.26349ZM15.7659 7.41077C17.6024 7.41077 17.7127 10.5112 17.7178 11.9676L17.718 12.1033C17.718 13.4173 17.6429 16.8149 15.7659 16.8149C13.9476 16.8149 13.8027 13.6439 13.7954 12.2341L13.7951 12.1033C13.7951 10.7517 13.8514 7.41077 15.7659 7.41077Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine10);
export { ForwardRef as ReactComponent };
